(function() {
  'use strict';

  function initSwatchesTabs() {
    const swatchesTabs = document.getElementById('swatchesTabs');
    const swatchesList = document.getElementById('swatchesList');
    
    if (!swatchesTabs || !swatchesList) {
      return;
    }

    const swatchItems = swatchesList.querySelectorAll('.swatches-list-item');
    
    if (swatchItems.length === 0) {
      return;
    }

    function updateContainerVisibility() {
      const containers = swatchesList.querySelectorAll('.swatches-list-item-container');
      containers.forEach(container => {
        const items = container.querySelectorAll('.swatches-list-item');
        let hasVisible = false;
        items.forEach(item => {
          if (item.style.display !== 'none') {
            hasVisible = true;
          }
        });
        container.style.display = hasVisible ? '' : 'none';
      });
    }

    // Get all unique productType values
    const productTypes = new Set();
    swatchItems.forEach(item => {
      const productType = item.getAttribute('data-productType');
      if (productType) {
        productTypes.add(productType);
      }
    });

    // Convert Set to Array and filter out 'Empty' if needed, or include it
    const productTypesArray = Array.from(productTypes).filter(type => type !== 'Empty');
    
    // Get initial product type from data-initialtype attribute
    const initialType = swatchesTabs.getAttribute('data-initialtype');
    
    // If we have product types, create tabs
    if (productTypesArray.length > 0) {
      // Determine which tab should be active initially
      let activeTabType = productTypesArray[0]; // Default to first tab
      if (initialType && initialType !== 'Empty' && productTypesArray.includes(initialType)) {
        activeTabType = initialType;
      }
      
      // Create tabs container
      const tabsContainer = document.createElement('div');
      tabsContainer.className = 'swatches-tabs-container';
      
      // Create tabs for each product type
      productTypesArray.forEach((productType) => {
        const tab = document.createElement('button');
        tab.className = 'swatches-tab';
        if (productType === activeTabType) {
          tab.classList.add('swatches-tab--active');
        }
        tab.setAttribute('data-tab', productType);
        tab.textContent = productType;
        tab.setAttribute('type', 'button');
        tabsContainer.appendChild(tab);
      });
      
      swatchesTabs.appendChild(tabsContainer);
      
      // Add click handlers to tabs
      const tabs = tabsContainer.querySelectorAll('.swatches-tab');
      tabs.forEach(tab => {
        tab.addEventListener('click', function() {
          const selectedTab = this.getAttribute('data-tab');
          
          // Update active state
          tabs.forEach(t => t.classList.remove('swatches-tab--active'));
          this.classList.add('swatches-tab--active');
          
          // Filter swatch items
          swatchItems.forEach(item => {
            const itemProductType = item.getAttribute('data-productType');
            
            if (itemProductType === selectedTab) {
              item.style.display = '';
            } else {
              item.style.display = 'none';
            }
          });

          updateContainerVisibility();
        });
      });
      
      // Initialize by showing only the active tab's items
      swatchItems.forEach(item => {
        const itemProductType = item.getAttribute('data-productType');
        if (itemProductType !== activeTabType) {
          item.style.display = 'none';
        }
      });

      updateContainerVisibility();
    }
  }

  const SIZE_OPTION_NAMES = ['größe', 'grösse', 'groesse', 'grosse', 'size'];

  function normalizeValue(value) {
    return (value || '').trim().toLowerCase();
  }

  function getSelectedSize() {
    const pickers = document.querySelectorAll('variant-selects');

    for (const picker of pickers) {
      const groups = picker.querySelectorAll('.product-form__input');

      for (const group of groups) {
        const nameHolder = group.querySelector('[data-selected-swatch-value]');
        const optionName = nameHolder ? nameHolder.getAttribute('data-selected-swatch-value') : '';

        // With a single option group the picker can only be the size selector
        if (groups.length > 1 && SIZE_OPTION_NAMES.indexOf(normalizeValue(optionName)) === -1) {
          continue;
        }

        const checkedInput = group.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
          return checkedInput.value;
        }

        const select = group.querySelector('select');
        if (select) {
          return select.value;
        }
      }
    }

    return null;
  }

  // The first size is preselected by the theme, so dimming only starts once the
  // shopper picks a size themselves (or lands on a URL with an explicit variant)
  let sizeWasChosen = new URLSearchParams(window.location.search).has('variant');

  function applySizeAvailability() {
    const swatchesList = document.getElementById('swatchesList');

    if (!swatchesList) {
      return;
    }

    const selectedSize = sizeWasChosen ? normalizeValue(getSelectedSize()) : '';
    const swatchItems = swatchesList.querySelectorAll('.swatches-list-item');

    swatchItems.forEach(item => {
      const sizesAttribute = item.getAttribute('data-available-sizes');

      if (!selectedSize || sizesAttribute === null) {
        item.classList.remove('is-size-unavailable');
        return;
      }

      const sizes = sizesAttribute.split(',').map(normalizeValue).filter(Boolean);
      item.classList.toggle('is-size-unavailable', sizes.indexOf(selectedSize) === -1);
    });
  }

  function init() {
    initSwatchesTabs();
    applySizeAvailability();
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when section is loaded in Shopify theme editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('#swatchesTabs')) {
      init();
    }
  });

  document.addEventListener('change', function(event) {
    if (event.target instanceof Element && event.target.closest('variant-selects')) {
      sizeWasChosen = true;
      applySizeAvailability();
    }
  });

  // The variant picker markup is re-rendered after the section fetch completes
  document.addEventListener('variant:changed', applySizeAvailability);
})();

